import firebase from "firebase";

firebase.initializeApp({
  apiKey: "AIzaSyBo-Qwt9KwVrkiEeH6EfPTUU7PAtd5E1FY",
  projectId: "all-my-sports-sa",
});

export const firebaseDb = firebase.firestore();
export const fireBaseAuth = firebase.auth();
